//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConfirmDialog from 'ui-kit/src/components/ConfirmDialog';
import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,

    props: {
        showAllLabel: String,
    },

    data() {
        return {
            showAll: !this.readonly,
        };
    },

    computed: {
        galleryPhotos() {
            let baseVehiclePhotos = [];
            let currentProtocolPhotos = [];
            let signedProtocolPhotos = [];

            if (this.collName === 'cases') {
                // For cases, add base vehicle photos...
                if (this.showAll) {
                    baseVehiclePhotos = this.editItem.vehicle.photos.map(p => ({
                        ...p,
                        readonly: true,
                    }));
                }

                // ... and current protocol photos (if not signed yet)
                if (!this.readonly || !this.showAll) {
                    currentProtocolPhotos = this.model.filter(p => !p.removed).map(p => ({
                        ...p,
                        signed: Date.now(),
                        noTitle: true,
                    }));
                }
            } else {
                // For vehicles, add base photos
                baseVehiclePhotos = this.model.filter(p => !p.removed);
            }

            // For both cases and vehicles, add all signed protocol photos
            if (this.showAll) {
                const vehicleRef = (this.collName === 'cases') ? this.editItem.vehicleRef : this.editItem.id;
                const cases = $.cases.filter(c => c.vehicleRef === vehicleRef && !c.isInternal && c.protocolOut.signed);

                signedProtocolPhotos = cases.flatMap(c => [
                    ...c.photosOut.map(p => ({
                        ...p,
                        case: c,
                        out: true,
                        signed: c.protocolOut.signed,
                        readonly: true,
                    })),
                    ...(!c.protocolIn.signed ? [] : c.photosIn.map(p => ({
                        ...p,
                        case: c,
                        in: true,
                        signed: c.protocolIn.signed,
                        readonly: true,
                    }))),
                ]);
            }

            return [
                ...baseVehiclePhotos,
                ...currentProtocolPhotos,
                ...signedProtocolPhotos,
            ];
        },
    },

    methods: {
        keyFn(photo) {
            return photo.name;
        },
        urlFn(photo) {
            return this.getUrl(photo, false);
        },
        thumbUrlFn(photo) {
            return this.getUrl(photo, true);
        },
        getUrl(photo, thumb) {
            return `${appConfig.app.baseApiUrl}/download?name=${photo.name}${photo.temp ? '&temp=true' : ''}${thumb ? '&thumb=true' : ''}`;
        },
        downloadFn(photo) {
            $.downloadFile(photo);
        },
        async removeFn(photo) {
            if (photo.temp) {
                $.removeOne(this.model, photo);

                return true;
            } else {
                return new Promise(resolve => {
                    this.$q.dialog({
                        component: ConfirmDialog,
                        title: this.$t(`confirm.remove.title.photos`),
                        message: this.$t(`confirm.remove.message.photos.${this.collName}`),
                        okLabel: 'Smazat',
                        cancelLabel: 'Storno',
                    }).onOk(() => {
                        $.set(photo, 'removed', true);

                        resolve(true);
                    }).onCancel(() => {
                        resolve(false);
                    });
                });
            }
        },
        groupKeyFn(photo) {
            return photo.signed || dayjs($.getFileTimestamp(photo.name)).startOf('day').valueOf();
        },
        groupKeyCompareFn(a, b) {
            return b - a;
        },
        onDrop(data) {
            if (data.files.length) {
                this.$refs.uploader.addFiles(data.files);
            }
        },
    },
};
